module.exports = __webpack_public_path__ + "img/imgback.a870950d.png";